export {
  default,
  getServerSideProps,
} from '@/views/B2BStudentOnboardingV2/pages/Welcome';
